import { useState } from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { NavLink } from "react-router-dom";
import { formatDate } from "../../../actions";
import { downloadDocument, openDocumentInNewTab } from "../actions";
import {
  ArrowTopRightOnSquareIcon,
  ArrowDownTrayIcon,
  PhotoIcon,
  DocumentTextIcon,
  VideoCameraIcon,
  MusicalNoteIcon,
  ArchiveBoxIcon,
  CodeBracketIcon,
} from "@heroicons/react/24/outline";

const DocumentsTableRow = ({ document, ...props }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleViewDocument = () => {
    props.openDocumentInNewTab(document._id);
  };

  const handleDownloadDocument = async() => {
    setIsDownloading(true);
    try {
      await props.downloadDocument(document._id, document.title);
    } finally {
      setIsDownloading(false);
    }
  };

  const getFileType = (mimetype) => {
    if (!mimetype) return "Unknown";
    const type = mimetype.split("/")[1];
    return type ? type.toUpperCase() : "Unknown";
  };

  const getFileTypeIcon = (mimetype) => {
    if (!mimetype) return DocumentTextIcon;

    const [category, type] = mimetype.split("/");

    // Image files
    if (category === "image") return PhotoIcon;

    // Video files
    if (category === "video") return VideoCameraIcon;

    // Audio files
    if (category === "audio") return MusicalNoteIcon;

    // Archive files
    if (
      type === "zip"
      || type === "rar"
      || type === "7z"
      || type === "tar"
      || type === "gz"
    ) {
      return ArchiveBoxIcon;
    }

    // Code files
    if (
      type === "js"
      || type === "ts"
      || type === "jsx"
      || type === "tsx"
      || type === "html"
      || type === "css"
      || type === "scss"
      || type === "sass"
      || type === "json"
      || type === "xml"
      || type === "yaml"
      || type === "yml"
    ) {
      return CodeBracketIcon;
    }

    // Default to document icon for text files, PDFs, etc.
    return DocumentTextIcon;
  };

  const renderCampaignCell = () => {
    const campaignName = document?.campaignName;
    const assignmentId = document?.assignment_id;
    if (assignmentId && campaignName) {
      return (
        <NavLink
          className="link-more"
          style={{ fontWeight: 700 }}
          to={`/campaigns/${assignmentId}`}
        >
          {campaignName}
        </NavLink>
      );
    }
    return <>{campaignName || ""}</>;
  };

  return (
    <tr className="activity-row">
      <th scope="row" className="tb-head text-grey">
        <div
          className="document-title link-more"
          onClick={handleViewDocument}
          style={{ cursor: "pointer" }}
        >
          {document.title || "Untitled Document"}
        </div>
      </th>
      <td>
        <div className="text-grey-bold">
          <span
            className="document-type-badge d-inline-flex align-items-center"
            style={{ gap: "0.5rem" }}
          >
            {(() => {
              const IconComponent = getFileTypeIcon(document.mimetype);
              return <IconComponent width={16} height={16} strokeWidth={2} />;
            })()}
            {getFileType(document.mimetype)}
          </span>
        </div>
      </td>
      <td>
        <div>{renderCampaignCell()}</div>
      </td>
      <td>
        <div className="text-grey-bold">
          {formatDate(document.created, {
            month: "short",
            day: "numeric",
            year: "numeric",
          })}
        </div>
      </td>
      <td className="text-center">
        <div className="text-grey-bold">
          <div
            className="d-flex justify-content-center"
            style={{ gap: "0.5rem" }}
          >
            <Button
              color="outline-primary"
              size="sm"
              onClick={handleViewDocument}
              title="View Document"
            >
              <ArrowTopRightOnSquareIcon
                width={16}
                height={16}
                strokeWidth={2}
              />
            </Button>
            <Button
              color="outline-primary"
              size="sm"
              onClick={handleDownloadDocument}
              disabled={isDownloading}
              title="Download Document"
            >
              <ArrowDownTrayIcon width={16} height={16} strokeWidth={2} />
            </Button>
          </div>
        </div>
      </td>
    </tr>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  downloadDocument,
  openDocumentInNewTab,
})(DocumentsTableRow);
